import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { AnalyticsDashboard } from '../modules/Analytics/AnalyticsDashboard';
import { analyticsAdminCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/analytics')({
  component: AnalyticsDashboard,
  loader(ctx) {
    const permissionCheck = analyticsAdminCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access the Analytics Dashboard. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Analytics Dashboard' }],
    };
  },
});
